export default {
  voicings: [
    'SA',
    'TB',
    'ST',
    'SB',
    'AT',
    'AB',
    'SAT',
    'SAB',
    'STB',
    'ATB',
    'ATT',
    'SSA',
    'SAA',
    'TTB',
    'TBB',
    'SATB',
    'SSATB',
    'SATTB',
    '2-pt',
    '3-pt',
    '4-pt',
    '5-pt',
    'Equal voices',
    'SSAA',
    'TTBB',
    'AAT',
    'AAA',
    'AAB',
    'SST',
    'AATT',
    'ATTB',
  ].sort(),
  // To update composers
  // f = [...new Set(x.map(i => i.composer))].sort()
  composers: [
    'Aichinger',
    'Anerio',
    'Anonymous',
    'Asola',
    'Beringer',
    'Bruckner',
    'Brumel',
    'Byrd',
    'Carturan',
    'Croce',
    'de Castro',
    'de la Rue',
    'des Pres',
    'Fux',
    'Gallus',
    'Guerrero',
    'Gumpelzhaimer',
    'Handl',
    'Hassler',
    'Isaac',
    'Lassus',
    'Lotti',
    'Marenzio',
    'Monteverdi',
    'Morales',
    'Morley',
    'Mouton',
    'Nanini',
    'Palestrina',
    'Parsons',
    'Pisari',
    'Tallis',
    'Tye',
    'Victoria',
  ].sort(),
  liturgicalSeason: [
    'Advent',
    'Advent 1',
    'Advent 2',
    'Advent 3',
    'Advent 4',
    'Epiphany',
    'Christmas',
    'Baptism of the Lord',
    'Lent',
    'Lent 1',
    'Lent 2',
    'Lent 3',
    'Lent 4',
    'Immaculate Conception',
    'Assumption',
    'Presentation of the Lord',
    'Peter and Paul',
    'Palm Sunday',
    'Holy Thursday',
    'Good Friday',
    'Easter Vigil',
    'All Saints',
    'All Souls',
    'Annunciation',
    'Apostles',
    'Ascension',
    'Assumption',
    'Baptism of the Lord',
    'Christ the King',
    'Christmas',
    'Corpus Christi',
    'December 26',
    'December 27',
    'Dedication of the Lateran Basilica',
    'Exaltation of the Holy Cross',
    'Nativity of John the Baptist',
    'Easter',
    'Easter 3',
    'Easter Vigil',
    'Easter',
    'Epiphany',
    'Exaltation of the Holy Cross',
    'February 2',
    'Good Friday',
    'Holy Thursday',
    'Immaculate Conception',
    'John the Evangelist',
    'Lent',
    'June 24',
    'June 29',
    'Lent 1',
    'Lent 2',
    'Lent 3',
    'Lent 4',
    'Nativity of John the Baptist',
    'November 1',
    'November 2',
    'November 9',
    'Ordinary Time',
    'OT',
    'OT 12',
    'OT 13-A',
    'OT 14',
    'OT 18',
    'OT 21',
    'OT 22',
    'OT 23',
    'OT 24',
    'OT 4-A',
    'OT 5-A',
    'OT 6',
    'OT 9-C',
    'Transfiguration',
    'Christ the King',
    'November 1',
    'June 24',
    'Annunciation',
    'June 29',
    'September 14',
    'Stephen the Martyr',
    'February 2',
    'Peter and Paul',
  ].sort(),
  massParts: [
    'Ad Libitum',
    'Bread from Heaven',
    'Candlemas',
    'Canon',
    'Communion',
    'Confirmation',
    'Doxology',
    'EMCY',
    'Eucharistic',
    'Funeral',
    'Gradual',
    'Introit',
    'John the Evangelist',
    'Low edition',
    'Marian',
    'Martyrs',
    'Offertory',
    'Procession',
    'Tract',
    'Trinity Sunday',
    'Canon',
    `Offertory Project`,
    `Graduale Simplex`,
  ].sort(),
  scripture: [
    'John',
    'John 11',
    'Isaiah',
    'Isaiah 53',
    'Isaiah 60',
    '1 Corinthians',
    '1 Corinthians 2',
    'Matthew',
    'Matthew 16',
    'Matthew 18',
    'Matthew 2',
    'Matthew 13',
    'Matthew 16',
    'Mark',
    'Mark 8',
    'Luke',
    'Luke 1',
    'Luke 2',
    'Luke 9',
    'Luke 14',
    'Psalm',
    'Psalm 137',
    'Psalm 34',
    'Psalm 78',
    'Psalm 47',
    'Psalm 146',
    'Psalm 6,',
    'Psalm 78',
    'Psalm 119',
    'Psalm 25',
    'Jeremiah 17',
    'Philippians',
    'Wisdom',
    'Galatians',
    'Acts',
    'Revelation',
    'Lamentations',
    'Song of Songs 2',
    'Romans 8',
    'Philippians 2',
  ].sort(),
};



// WEBPACK FOOTER //
// ./src/big-text/tags.js